import noop from 'lib/function/noop'
import { createReducer } from 'lib/redux/reducerUtils'
import { Dispatch, createContext } from 'react'
import { ValueOf } from 'type-fest'

// STATE
export enum BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS {
  PERSONAL_EMAIL_UPDATE,
  EXISTING_PERSONAL_USER,
  NEW_PERSONAL_USER,
  PERSONAL_ACCOUNT_LINK_CONFIRMATION,
}

export interface BusinessTravellerPersonalAccountLinkingState {
  businessDetails: {
    id: string
    name: string
  }
  personalEmail: string
  employeeProfile: {
    id: string
    email: string
    firstName?: string
    lastName?: string
  }
  step: BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS
}

const BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_INITIAL_STATE: BusinessTravellerPersonalAccountLinkingState = {
  businessDetails: {
    id: '',
    name: '',
  },
  employeeProfile: {
    id: '',
    email: '',
  },
  personalEmail: '',
  step: BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS.PERSONAL_EMAIL_UPDATE,
}

export const BusinessTravellerPersonalAccountLinkingStateContext =
  createContext<BusinessTravellerPersonalAccountLinkingState>(BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_INITIAL_STATE)

// DISPATCH
export enum BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_ACTIONS {
  STEP_INTO = 'STEP_INTO',
  SET_PERSONAL_EMAIL = 'SET_PERSONAL_EMAIL',
}

export type BusinessTravellerPersonalAccountLinkingDispatchAction = ValueOf<Utils.FullActionMap<{
  [BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_ACTIONS.STEP_INTO]: {
    step?: BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_STEPS
  },
  [BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_ACTIONS.SET_PERSONAL_EMAIL]: {
    personalEmail?: string
  },
}>>

export const businessTravellerPersonalAccountLinkingStateReducer = createReducer<BusinessTravellerPersonalAccountLinkingState, BusinessTravellerPersonalAccountLinkingDispatchAction>(
  BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_INITIAL_STATE,
  {
    [BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_ACTIONS.STEP_INTO]: (state, action) => ({
      step: action.step,
    }),
    [BUSINESS_TRAVELLER_PERSONAL_ACCOUNT_LINKING_ACTIONS.SET_PERSONAL_EMAIL]: (state, action) => ({
      personalEmail: action.personalEmail,
    }),
  },
)

export const BusinessTravellerPersonalAccountLinkingDispatchContext =
  createContext<Dispatch<BusinessTravellerPersonalAccountLinkingDispatchAction>>(noop)
